import {
  PatientSuggestionsPerDiseaseMetrics,
  Qualifier,
} from "fe-common/graphql";
import { sameQualifers } from "../../dataInputTypes";
import { groupBy } from "fe-common/ui/arrayUtils";
import { useCallback } from "react";
import { SuggestionDiseaseStrength } from "../hooks/useSuggestions";

const suggestionsQualifiers = (
  s: PatientSuggestionsPerDiseaseMetrics,
): Qualifier[] => s.suggestion.qualifiers;

export function useFindingClinicalReason(
  causedByDisease: (PatientSuggestionsPerDiseaseMetrics &
    SuggestionDiseaseStrength)[],
) {
  return useCallback(
    (q?: Qualifier): SuggestionDiseaseStrength[] => {
      if (!causedByDisease) return null;

      const diseasesWithStrength = q
        ? causedByDisease.filter((prob) =>
            suggestionsQualifiers(prob).some((q1) => sameQualifers(q1, q)),
          )
        : causedByDisease;

      //for each disease use maximum strength (might be a few since the suggestion is mapped to a subtype)
      const groupedDiseasesWithStrength = groupBy(
        diseasesWithStrength,
        (d) => d.disease.id,
      );
      const diseasesWithStrengthUnique = [];
      Object.keys(groupedDiseasesWithStrength).forEach((key) => {
        const maxStrength = groupedDiseasesWithStrength[key].reduce(
          (acc, item) => {
            acc = Math.max(item.strength, acc);
            return acc;
          },
          0,
        );
        diseasesWithStrengthUnique.push({
          disease: groupedDiseasesWithStrength[key][0].disease,
          strength: maxStrength,
        });
      });

      return diseasesWithStrengthUnique.sort((a, b) => b.strength - a.strength);
    },
    [causedByDisease],
  );
}
